/**
 * im创建群聊操作界面
 * Bai.Zhiming
 * 2019-7-18
 */
angular.module('imCreateGroupModule', [
    'createGroupServiceModule'
]).
directive('imCreateGroup', ['$q', '$timeout', 'imService', 'modalDialog', 'createGroupService', 'trsHttpService', '$filter', function($q, $timeout, imService, modalDialog, createGroupService, trsHttpService, $filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            finish: '&',
            close: '&',
            loginInfo: '=',
            editGroupInfo: '='
        },
        templateUrl: './IM/chatWindow/chatDirectory/groupDirectory/createGroup/imCreateGroup_tpl.html',
        link(scope, $element, $attrs) {
            initStatus();
            initData();
            /**
             * [deleteUser description] 剔除用户
             * @param  {[type]} user [description] 用户信息
             * @return {[type]}      [description]
             */
            scope.deleteUser = function(user) {
                let result = scope.userIsSelected(user);
                scope.data.selectedUserList.splice(result.index, 1);
            };
            /**
             * [selectUser description] 选择用户
             * @param  {[type]} user [description]
             * @return {[type]}      [description]
             */
            scope.selectUser = function(user) {
                let account = `${user.TENANTID}_${user.USERNAME}`;
                let myAccount = `${scope.loginInfo.TENANTID}_${scope.loginInfo.USERNAME}`;
                if (account == myAccount) {
                    return;
                }
                let result = scope.userIsSelected(user);
                if (!result.flag) {
                    scope.data.selectedUserList.push(user);
                    imService.applyAddFriend(account, myAccount);
                } else {
                    scope.data.selectedUserList.splice(result.index, 1);
                }
            };
            /**
             * [userIsSelected description] 用户是否已经被选中
             * @param  {[type]} user [description] 被监测用户
             * @return {[type]}      [description]
             */
            scope.userIsSelected = function(user) {
                let result = {
                    flag: false
                }
                for (let i in scope.data.selectedUserList) {
                    let theUser = scope.data.selectedUserList[i];
                    if (user.USERNAME == theUser.USERNAME) {
                        result.flag = true;
                        result.index = i;
                        break;
                    }
                }
                return result;
            };
            /**
             * [confirm description] 确定
             * @return {[type]} [description]
             */
            scope.confirm = function() {
                if (scope.data.selectedUserList.length == 1) {
                    modalDialog.alertType("群组里至少有一个其他成员", "", "warning", 'confirm');
                    return;
                }
                let selectedUserList = scope.data.selectedUserList.filter(item => { //剔除掉自己
                    return `${item.TENANTID}_${item.USERNAME}` != `${scope.loginInfo.TENANTID}_${scope.loginInfo.USERNAME}`;
                });
                if (angular.isObject(scope.editGroupInfo)) {
                    scope.loaders = changeGroupMember();
                    return;
                }
                scope.loaders = createGroup(selectedUserList);
                //scope.finish();
            };
            /**
             * [changeGroupMember description] 改变群成员
             * @return {[type]} [description]
             */
            function changeGroupMember() {
                let deffer = $q.defer();
                let kickOutArray, joinArray;
                let orgMemberList = scope.data.orgEditGroupInfo.memberList;
                let memberList = scope.data.selectedUserList;
                kickOutArray = orgMemberList.filter(item => { //踢掉的人
                    return memberList.every(item_ => {
                        return `${item.TENANTID}_${item.USERNAME}` != `${item_.TENANTID}_${item_.USERNAME}`;
                    });
                });
                joinArray = memberList.filter(item => { //新加入的人
                    return orgMemberList.every(item_ => {
                        return `${item.TENANTID}_${item.USERNAME}` != `${item_.TENANTID}_${item_.USERNAME}`;
                    });
                });
                if (kickOutArray.length == 0 && joinArray.length == 0) {
                    scope.finish();
                    return;
                }
                $q.all([kickOutMembers(kickOutArray), joinMember(joinArray)]).then(resp => {
                    modalDialog.alertType("更改群成员成功", "", "success", false, () => {
                        deffer.resolve();
                        scope.finish();
                    });
                }, err => {
                    modalDialog.alertType("更改群成员发生错误", "", "warning", false);
                    deffer.reject();
                    scope.finish();
                });
                return deffer.promise;
            }
            /**
             * [kickOutMembers description] 将制定成员踢出群聊
             * @param  {[type]} kickOutArray [description] 成员数组
             * @return {[type]}              [description]
             */
            function kickOutMembers(kickOutArray) {
                let deffer = $q.defer();
                if (kickOutArray.length == 0) {
                    deffer.resolve();
                } else {
                    kickOutArray = kickOutArray.map(item => {
                        return `${item.TENANTID}_${item.USERNAME}`
                    });
                    imService.deleteGroupMember(scope.editGroupInfo.groupId, kickOutArray).then(resp => {
                        deffer.resolve(resp);
                    }, err => {
                        deffer.reject(err);
                    });
                }
                return deffer.promise;
            }
            /**
             * [joinMember description] 拉人入群
             * @param  {[type]} joinArray [description] 成员数组
             * @return {[type]}           [description]
             */
            function joinMember(joinArray) {
                let deffer = $q.defer();
                if (joinArray.length == 0) {
                    deffer.resolve();
                } else {
                    joinArray = joinArray.map(item => {
                        return `${item.TENANTID}_${item.USERNAME}`
                    });
                    imService.addGroupMember(scope.editGroupInfo.groupId, joinArray).then(resp => {
                        deffer.resolve(resp);
                    }, err => {
                        if (err.ErrorCode == 10019) {
                            modalDialog.alertType("您邀请的账号在聊天系统中不存在", "", "warning", "confirm");
                        }
                        deffer.reject(err);
                    });
                }
                return deffer.promise;
            }
            /**
             * [createGroup description] 创建群组
             * @return {[type]} [description]
             */
            function createGroup(selectedUserList) {
                let deffer = $q.defer();
                createGroupService.groupInfo().then(groupInfo => {
                    let options = {
                        /*ApplyJoinOption: "NeedPermission",*/ //私有群不能传该参数
                        GroupId: Math.round(Math.random() * 1e12) + "",
                        Introduction: groupInfo.Introduction ? groupInfo.Introduction : `由用户${scope.loginInfo.TRUENAME}在${$filter('date')(new Date(),'yyyy-MM-dd HH:mm')}创建的群，名称为${groupInfo.groupName}`,
                        MemberList: selectedUserList.map(item => {
                            return `${item.TENANTID}_${item.USERNAME}`
                        }),
                        Name: groupInfo.groupName,
                        FaceUrl: groupInfo.groupImage,
                        Notification: groupInfo.Notification ? groupInfo.Notification : `由用户${scope.loginInfo.TRUENAME}在${$filter('date')(new Date(),'yyyy-MM-dd HH:mm')}创建的群，名称为${groupInfo.groupName}`,
                        Owner_Account: `${scope.loginInfo.TENANTID}_${scope.loginInfo.USERNAME}`,
                        Type: "Private"
                    };
                    if (!options.FaceUrl) delete options.FaceUrl;
                    webim.createGroup(
                        options,
                        function(resp) {
                            deffer.resolve();
                            $timeout(() => { //更新群组头像信息
                                imService.getJoinedGroupListHigh(`${scope.loginInfo.TENANTID}_${scope.loginInfo.USERNAME}`);
                            }, 400);
                            scope.finish();
                        },
                        function(err) {
                            if(err.ErrorCode==10004){
                                modalDialog.alertType("图片地址过长", err.ErrorCode, "error", 'confirm');
                            }else{
                                modalDialog.alertType("创建失败", err.ErrorCode, "error", 'confirm');
                            }
                            deffer.reject();
                        }
                    );
                }, () => {
                    deffer.reject();
                });
                return deffer.promise;
            }
            /**
             * [cancel description] 取消
             * @return {[type]} [description]
             */
            scope.cancel = function() {
                scope.close();
            };
            /**
             * [queryTenantUsers description] 获取租户下用户信息
             * @return {[type]} [description]
             */
            function queryTenantUsers() {
                let deffer = $q.defer();
                let params = {
                    serviceid: "mlf_usermanagement",
                    methodname: "queryTenantUsers",
                    keyWords: scope.status.keyWords
                };
                scope.loaders = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(resp => {
                    scope.data.userList = resp;
                });
            }
            scope.search = function() {
                if (scope.status.searchTimer) {
                    clearTimeout(scope.status.searchTimer);
                    scope.status.searchTimer = null;
                }
                scope.status.searchTimer = setTimeout(queryTenantUsers, 1000);
            };
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                console.log(scope.loginInfo);
                scope.status = {
                    keyWords: '',
                    searchTimer: ''
                };
                scope.data = {
                    userList: [],
                    selectedUserList: angular.isObject(scope.editGroupInfo) ? scope.editGroupInfo.memberList : [{
                        USERNAME: scope.loginInfo.USERNAME,
                        UNAME: scope.loginInfo.TRUENAME,
                        TENANTID: scope.loginInfo.TENANTID,
                        USERHEAD: scope.loginInfo.USERHEAD
                    }],
                    orgEditGroupInfo: angular.copy(scope.editGroupInfo)
                };
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                queryTenantUsers();
            }
        }
    };
}]);